<template>
	<div class="col align-items-center d-flex flex-lg-column justify-content-around">
		<div class="d-flex flex-grow-1 w-100">
			<div class="box m-auto" v-if="!kiddingMode">
				<h4 class="mb-3 text-center text-light">Captives</h4>
				<div class="captives d-flex justify-content-around">
					<Stone
						class="captive"
						v-for="i in captives"
						:class="{ p1: forPlayer == 1, p2: forPlayer == 2 }"
						:gpv="captiveGpv"
						:key="i"
					/>
				</div>
			</div>
		</div>
		<div class="flex-grow-1 template-wrapper w-100">
			<div class="box">
				<div class="m-auto template-ph">
					<TemplateStone
						v-if="(currentPlayer == forPlayer || kiddingMode) && showTemplate"
						:initialDirection="initialDirection"
						:player="forPlayer"
						@dragend="forwardDragend"
						@rotated="updateInitialDirection"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["conflicts", "currentPlayer", "forPlayer", "kiddingMode", "showTemplate"],
	data() {
		return {
			initialDirection: this.forPlayer == 1 ? 0 : 2
		}
	},
	computed: {
		captives() {
			let c = this.conflicts;
			if (this.forPlayer == 1) c *= -1;
			return Math.max(0, c);
		},
		captiveGpv() {
			const d = this.forPlayer == 1 ? 0 : 2;
			const p = this.forPlayer == 1 ? 2 : 1;
			return [0, 0, d, p];
		}
	},
	methods: {
		forwardDragend(data) {
			this.$emit("dragend", data);
		},
		updateInitialDirection(direction) {
			this.initialDirection = direction;
		}
	}
};
</script>

<style lang="scss">
@import "@/scss/sizing.scss";
.box {
	background: rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 0.5rem;
	box-shadow: inset 4px 4px 10px 0px rgba(0, 0, 0, 0.25);
	margin: auto;
	padding: 1rem;
	width: 100%;
	@include cell-size(2.5);
}

.captives {
	height: 50px;
}

.captive.stone {
	height: 50px;
	min-height: 0;
	min-width: 0;
	width: 10px;

	svg {
		width: 50px;
	}

	&.p1 svg {
		margin-left: -12.5px;
	}
	&.p2 svg {
		margin-left: -25px;
	}
}

.template-ph {
	@include stone-size;
}
.template-wrapper {
	z-index: 2;
}
</style>